// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import EllipsisOutlinedSvg from "@fishx/icons-svg/es/asn/EllipsisOutlined";
import FishxIcon from '../components/FishxIcon';

var EllipsisOutlined = function EllipsisOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: EllipsisOutlinedSvg
  }));
};

EllipsisOutlined.displayName = 'EllipsisOutlined';
export default React.forwardRef(EllipsisOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/EllipsisOutlined.js
// module id = 2604
// module chunks = 0